import styles from "./Sidebar.module.css";

export type RouteId =
  | "home"
  | "analytics"
  | "errors"
  | "bug-reports"
  | "feature-requests";

interface NavItem {
  id: RouteId;
  label: string;
  hash: string;
}

const ITEMS: NavItem[] = [
  { id: "home", label: "Home", hash: "#/" },
  { id: "analytics", label: "Analytics", hash: "#/analytics" },
  { id: "errors", label: "Errors", hash: "#/errors" },
  { id: "bug-reports", label: "Bug reports", hash: "#/bug-reports" },
  { id: "feature-requests", label: "Feature requests", hash: "#/feature-requests" },
];

export function Sidebar({ current }: { current: RouteId }) {
  return (
    <aside className={styles.sidebar}>
      <div className={styles.brand}>
        <span className={styles.brandMark}>Atlas Desk</span>
        <span className={styles.brandSub}>Admin</span>
      </div>
      <nav className={styles.nav}>
        {ITEMS.map((item) => (
          <a
            key={item.id}
            href={item.hash}
            className={
              current === item.id
                ? `${styles.navItem} ${styles.navItemActive}`
                : styles.navItem
            }
          >
            {item.label}
          </a>
        ))}
      </nav>
      <div className={styles.footer}>
        Cloudflare Access · Single admin
      </div>
    </aside>
  );
}
